<template lang="pug">
.conbox 
  .profile-wrapper
    .probox.pointer(@click="gamification()")
      .bbg
        img(src='assets/img/profile/bg.png')
      .avatar(:style="'background-image:url('+getAvatar+')'")
      .info
        .name {{smarticoData.public_username}}
        .levelbar
          .level.current {{getCurrentlvlDetails.name}}
          .levbar
            span(:style="calcWidth(smarticoData.ach_points_balance, getNextlvlDetails.required_points)")
          .level.next {{getNextlvlDetails.name}}
        .target 
          b {{getNextlvlDetails.required_points - smarticoData.ach_points_balance}}
          | points to unlock the next level
    .proeve
      a(href='javascript:void(0)' @click="gamification('wheel')")
        img(src='assets/img/profile/wheel.gif')
        span Spin
      a(href='javascript:void(0)' @click="gamification('cashback')")
        img(src='assets/img/profile/cashback.gif')
        span Cashback
    .proinfo
      .probals
        .label Total Balance
        .amount.pointer(@click="redirectPath('deposit')")
          span PHP {{ $numeral(getBalance).format("0,0.00") }}  
          i.far.fa-eye
      .proinfo-details
        // <div><small>Token</small><span>20</span></div>
        div
          small Points
          span.pointer(@click="gamification()") {{smarticoData.ach_points_balance}}
        div
          small Badges
          span.pointer(@click="gamification()") {{getBadges}}
        div
          small Missions
          span.pointer(@click="gamification()") {{ getMissions }}
    .proextra
      //- router-link(to="deposit")
      a(href="javascript:void(0)" @click="redirectPath('deposit')")
        img(src='assets/img/menu/m-depo.png')
        span Deposit
      //- router-link(to="withdrawal")
      a(href="javascript:void(0)" @click="redirectPath('withdrawal')")
        img(src='assets/img/menu/m-withdraw.png')
        span Withdrawal
      a(href='javascript:void(0)' @click="showTrans")
        img(src='assets/img/menu/m-trans.png')
        span Transaction
    .prolink
      .plrow
        .ttop
          a(href="javascript:void(0)" @click="redirectPath('setting')")
            span Profile Update
            i.fa.fa-chevron-right
      //- .plrow.vv-accor-row(:class="{'aaa' : showWinning === true}" @click="toggleWinning")
        .ttop
          a(href='javascript:void(0)')
            span Epic Winnings
            i.fa.fa-chevron-right
        .ccon
          template(v-if="topGame.length> 0")
            a(v-for="(game, index) in topGame" href="javascript:void(0)" style="color:#fff000")
              | {{ index + 1 }}. {{ game.game_name }} ({{ provider[game.provider_code] }}) - PHP {{ $numeral(game.winlose).format("0,0.00") }}
          template(v-else)
            a.text-center.text-white
              i.fa-regular.fa-newspaper.display-6
              div No data
      .plrow
        .ttop
          a(href='javascript:void(0)' @click="gamification('event')")
            span Limited Time Mission
            i.fa.fa-chevron-right
      .plrow.vv-accor-row(:class="{'aaa' : showMissions === true}" @click="toggleDisplay")
        .ttop
          a.vv-accor-act(href='javascript:void(0)')
            span Missions
            i.fa.fa-chevron-right
        .ccon
          a(href='javascript:void(0)' @click="gamification('daily')")
            img(src='assets/img/profile/daily.png')
            | Daily Mission
          a(href='javascript:void(0)' @click="gamification('weekly')")
            img(src='assets/img/profile/weekly.png')
            | Weekly Mission
          a(href='javascript:void(0)' @click="gamification('monthly')")
            img(src='assets/img/profile/monthly.png')
            | Monthly Mission
      .plrow
        .ttop
          a(href='javascript:void(0)' @click="gamification('level')")
            span Levels
            i.fa.fa-chevron-right
      .plrow
        .ttop
          //- router-link(to='referral')
          a(href="javascript:void(0)" @click="redirectPath('referral')")
            span Refer and Earn
            i.fa.fa-chevron-right
      .plrow
        .ttop
          a(href='javascript:void(0)' @click="gamification('tournament')")
            span Tournament
            i.fa.fa-chevron-right
      .plrow
        .ttop
          //- router-link(to='inbox')
          a(href="javascript:void(0)" @click="redirectPath('inbox')")
            span Inbox
            i.fa.fa-chevron-right

</template>
<script>
export default{
  data(){
    return{
      levels:[
        {id: '708'},
        {id: '709'},
        {id: '707'},
        {id: '710'},
        {id: '711'},
        {id: '712'},
        {id: '800'},
        {id: '801'},
        {id: '802'},
        {id: '803'},
      ],
      showMissions: false,
      showWinning: false,
      topGame: false,
      provider:{
        "LIVE22" : "LIVE22",
        "JILI2" : "JILI",
        "PG" : "PGSOFT",
        "FASTSPIN" : "FASTSPIN",
        "YESBINGO": "YESBINGO",
        "YL": "YLGAMING",
        "JDB": "JDB",
        "FC" : "FACHAI",
        "PP-S123" : "PRAGMATIC",
        "MG": "MICROGAMING",
        "SPNX": "SPINIX",
        "SPDG": "SPADEGAMING",
        "BG-S": "BGAMING",
        "HSD":"HACKSAW",
        "RG":"RELAXGAMING",
        "EVOP":"EVOPLAY",
        "PNG":"PLAY'NGO",
        "EVONTT":"NETENT",
        "EVORT":"REDTIGER",
        "EVONLC":"NLC",
        "BNG":"BNG",
        "AP":"ADVANTPLAY",
        "ALG":"ALIZE",
        "EPIC2": "EpicWin"
      }
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getAvatar(){
      return this.$store.getters.getAvatar
    },
    smarticoData(){
      return this.$store.getters.getSmarticoData
    },
    getMissions(){
      return this.$store.getters.getMissions
    },
    getBadges(){
      return this.$store.getters.getBadges
    },
    getBalance(){
      return this.$store.state.user.balance
    },
    getCurrentlvlDetails(){
      return this.$store.state.user.currentLevelDetails;
    },
    getNextlvlDetails(){
      return this.$store.state.user.nextLevelDetails;
    },
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    },
  },
  mounted(){
    // console.log(this.getCurrentlvlDetails, this.getNextlvlDetails)
    // this.getTopgame()
  },
  methods:{
    getTopgame(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getTopgame", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              this.topGame = response.data
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {console.log(response)
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        return
      }
    },
    redirectPath(target){
      this.$router.push({
        name:target,
        params:{
          "checkProfile": true
        }
      }).catch(error =>{})
    },
    toggleWinning(){
      this.showWinning = !this.showWinning
    },
    toggleDisplay(){
      this.showMissions = !this.showMissions
    },
    showTrans(){
      this.$router.push({
        name:"statement",
        params:{
          "checkTrans": true,
          "checkProfile": true
        }
      }).catch(error =>{})
    },
    calcWidth(current, target){
      var width = (current/ target).toFixed(2) * 100
      return "width: " + width + "%"
    },
    gamification(target){
      switch(target){
        case 'wheel':
          _smartico.dp("dp:gf_saw")
          break;
        case 'cashback':
          _smartico.dp("dp:gf_store")
          break;
        case 'event':
          _smartico.dp("dp:gf_section&id=203")
          break;
        case 'daily':
          _smartico.dp("dp:gf_section&id=251")
          break;
        case 'weekly':
          _smartico.dp("dp:gf_section&id=203")
          break;
        case 'monthly':
          _smartico.dp("dp:gf_section&id=204")
          break;
        case 'rules':
          _smartico.dp("dp:gf_section&id=91")
          break;
        case 'level':
          _smartico.dp("dp:gf_levels")
          break;
        case 'tournament':
          _smartico.dp("dp:gf_tournaments&id=1207")
          break;
        default:
          _smartico.dp("dp:gf")
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ccon{
  background: rgba(0,0,0,0.8) !important;
}
</style>